import { useEffect } from "react";

function useSaveShortcut() {
  useEffect(() => {
    function handleKeyDown(e) {
      const isSave = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "s";

      if (!isSave || e.repeat) return;

      // const tag = e.target.tagName.toLowerCase();
      // const isEditable = e.target.isContentEditable;

      // if (
      //   tag === "input" ||
      //   tag === "textarea" ||
      //   tag === "select" ||
      //   isEditable
      // ) {
      //   return;
      // }

      const btn = document.querySelector('[data-action="salvar"]');
      if (!btn) return;

      e.preventDefault();

      if (btn.offsetParent !== null) {
        btn.click();
      }
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
}

export default useSaveShortcut;
